import type { MutableRefObject, RefObject } from 'react'
import { useEffect, useRef } from 'react'

export const useClickOutside = (
    handleOnClickOutside: (event: MouseEvent | TouchEvent) => void,
    refNode?: RefObject<HTMLElement>,
): MutableRefObject<HTMLElement | null> => {
    // useEffect(() => {
    //     const listener = (event: MouseEvent | TouchEvent) => {
    //         if (ref.current && ref.current.contains(event.target as Node)) {
    //             handleOnClickOutside(event)
    //         }
    //     }

    //     // Add event listeners
    //     document.addEventListener('mousedown', listener)
    //     document.addEventListener('touchstart', listener)

    //     // Cleanup function to remove event listeners
    //     return () => {
    //         document.removeEventListener('mousedown', listener)
    //         document.removeEventListener('touchstart', listener)
    //     }
    // }, [ref.current, handleOnClickOutside]) // Use ref.current as dependency to avoid stale closures
    const domNode = useRef<HTMLElement | null>(null)

    useEffect(() => {
        const eventHandler = (event: MouseEvent) => {
            if (
                domNode.current &&
                !domNode.current.contains(event.target as Node)
            ) {
                if (
                    refNode &&
                    refNode.current &&
                    refNode.current.contains(event.target as Node)
                ) {
                    return
                }

                handleOnClickOutside(event)
            }
        }

        document.addEventListener('mousedown', eventHandler)

        return () => {
            document.removeEventListener('mousedown', eventHandler)
        }
    }, [handleOnClickOutside, refNode])

    return domNode
}
